import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    attemptedChallengeList : [],
    selectedAttemptedChallenge:{},
}
const attemptedChallengeSlice = createSlice({
    name:'attemptedChallenge',
    initialState,
    reducers:{
        setAttemptedChallengeList:(state,{payload})=>{
            state.attemptedChallengeList = payload
        },
        setAttemptedChallengeProfile:(state,{payload})=>{
            state.selectedAttemptedChallenge = payload
        },
    }
})

export const { setAttemptedChallengeList,setAttemptedChallengeProfile} = attemptedChallengeSlice.actions
export default attemptedChallengeSlice.reducer